var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZoomIn = function SvgZoomIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.542 20.596-6.28-6.28q-.75.618-1.726.968-.975.35-2.017.35-2.563 0-4.34-1.775-1.775-1.775-1.775-4.338t1.775-4.34 4.339-1.777 4.34 1.776q1.776 1.775 1.776 4.34 0 1.07-.359 2.045-.36.976-.96 1.696l6.281 6.281zM9.52 14.135q1.933 0 3.274-1.342 1.342-1.34 1.342-3.274t-1.342-3.274q-1.34-1.341-3.274-1.341-1.932 0-3.274 1.341Q4.904 7.586 4.904 9.52t1.341 3.274 3.274 1.342m-.75-1.924V10.27H6.827v-1.5h1.942V6.827h1.5v1.942h1.942v1.5H10.27v1.942z"
  })));
};
export default SvgZoomIn;